import { useFormik } from "formik";
import { SugerenciaForm } from "./form";
import { sugerenciaEmpaqueInitialValues } from "../constants";
import { sugerenciaEmpaqueValidationSchema } from "../validation";
import { useSugerencia } from "../hooks/useSugerencia";
import Swal from "sweetalert2";
import axios from "axios";

export const AgregarSugerenciaEmpaque = ({ onRefresh, onCancel }) => {
  const { createSugerencia, isSaving } = useSugerencia();
  const onSubmit = async (values) => {
    try {
      await createSugerencia(values);
      Swal.fire({
        icon: "success",
        title: "Sugerencia guardada",
        timer: 1500,
      });
      resetForm();
      onRefresh();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Algo salió mal!",
            text: `${error.response.data.msg} - Si el error persiste favor de comunicar al equipo de desarrollo`,
          });
          return;
        }
      }

      Swal.fire({
        icon: "error",
        title: "Algo salió mal!",
        text: `Favor de comunicar al equipo de desarrollo`,
      });
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    onSubmit,
    initialValues: sugerenciaEmpaqueInitialValues,
    validationSchema: sugerenciaEmpaqueValidationSchema,
  });

  return (
    <SugerenciaForm
      values={values}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      errors={errors}
      touched={touched}
      handleSubmit={handleSubmit}
      isLoading={isSaving}
      onCancel={onCancel}
    />
  );
};
